import { render, staticRenderFns } from "./SnackbarActualizar.vue?vue&type=template&id=66e5acdb&"
import script from "./SnackbarActualizar.vue?vue&type=script&lang=ts&"
export * from "./SnackbarActualizar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports